import React, { FunctionComponent } from 'react';
import { Grid } from '@mlc/web-ui-toolkit';

interface Props {
	children: JSX.Element | JSX.Element[];
}

const ClientDataExchange: FunctionComponent<Props> = ({ children }) => {
	return <Grid>{children}</Grid>;
};

export default ClientDataExchange;
